import { render } from "./MarkdownRead.vue?vue&type=template&id=e16e99d8&scoped=true"
import script from "./MarkdownRead.vue?vue&type=script&lang=js"
export * from "./MarkdownRead.vue?vue&type=script&lang=js"

import "./MarkdownRead.vue?vue&type=style&index=0&id=e16e99d8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e16e99d8"]])

export default __exports__